module.exports = __webpack_public_path__ + "static/img/tansuanyinliao.a32bbd57.png";